import React from 'react';
import PropTypes from 'prop-types';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import { redirectNewCampaignsToEngageBuilderV2, requireEngagePermission } from '../auth/routerHooks';
import BackButton from './components/BackButton';
import ViewCampaign from './containers/ViewCampaign';
import Layout from './containers/Layout';
import { ListLayout } from '../../modules/shared/engage/campaign-list/list-layout';
import withNewDesignStyles from '../common/hoc/withNewDesignStyles';
import CampaignDraft from './containers/CampaignDraft';
import DraftActions from './components/DraftActions';
import PayCampaign from './containers/PayCampaign';
import CampaignPayActions from './containers/CampaignPayActions';
import { CampaignList } from '../../modules/shared/engage/campaign-list';
import { EngageHeaderControls } from '../../modules/shared/engage/campaign-list/header-controls';
import withoutPageHeader from '../common/hoc/withoutPageHeader';
import { AutomatedListView } from '../../modules/shared/engage/automated/automated-list-view';
import { useFeatureFlags } from '../../modules/infra/feature-flags';
import { t } from '../../modules/infra/i18n';

const createTitle = (text) => <span data-automation-id="text:header">{text}</span>;

const BackButtonToEngage = () => <BackButton to="/engagement" />;

const EngagementRoot = ({ title, controls, content, children }) => {
  const { automatedCampaigns } = useFeatureFlags();
  const Root = automatedCampaigns ? withoutPageHeader(ListLayout) : withNewDesignStyles(Layout);

  if (automatedCampaigns) {
    // ListLayout expects children only
    return <Root>{children}</Root>;
  }

  // Layout expects named slots
  return <Root title={title} controls={controls} content={content} />;
};

EngagementRoot.propTypes = {
  title: PropTypes.node,
  controls: PropTypes.node,
  content: PropTypes.node,
  children: PropTypes.node,
};
EngagementRoot.defaultProps = {
  title: null,
  controls: null,
  content: null,
  children: null,
};

const EngagementTitle = () => {
  const { automatedCampaigns } = useFeatureFlags();
  return automatedCampaigns ? null : createTitle(t('engage:title'));
};

const EngagementControls = () => {
  const { automatedCampaigns } = useFeatureFlags();
  return automatedCampaigns ? null : <EngageHeaderControls />;
};

const EngagementContent = () => {
  const { automatedCampaigns } = useFeatureFlags();
  return automatedCampaigns ? null : <CampaignList />;
};

const EngagementChildren = () => {
  const { automatedCampaigns } = useFeatureFlags();
  return automatedCampaigns ? <CampaignList /> : null;
};
const Routes = (store) => (
  <Route path="engagement" component={EngagementRoot} onEnter={requireEngagePermission(store)}>
    <IndexRoute
      components={{
        title: EngagementTitle,
        controls: EngagementControls,
        content: EngagementContent,
        children: EngagementChildren,
      }}
    />
    <Route path="automated" components={{ children: AutomatedListView }} />
    <Route
      path="new"
      components={{ title: () => createTitle(t('engage:title_clients')), controls: DraftActions, content: CampaignDraft }}
      onEnter={redirectNewCampaignsToEngageBuilderV2()}
    />
    <Route
      path=":campaignId"
      components={{ title: () => createTitle(t('engage:title_clients')), controls: DraftActions, content: CampaignDraft }}
    />
    <Route
      path=":campaignId/view"
      components={{
        title: () => createTitle(t('engage:title_clients')),
        controls: BackButtonToEngage,
        content: ViewCampaign,
      }}
    />
    <Route
      path=":campaignId/charge"
      components={{ title: () => createTitle(t('engage:title_clients')), controls: CampaignPayActions, content: PayCampaign }}
    />
  </Route>
);

export default Routes;
